var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.2203 27.774H2.77967C1.25368 27.774 0 29.022 0 30.5537V47.2203C0 48.7463 1.24801 50 2.77967 50H47.2203C48.7463 50 50 48.752 50 47.2203V30.5537C50 29.0277 48.752 27.774 47.2203 27.774ZM11.113 44.4407C8.05536 44.4407 5.55933 41.939 5.55933 38.887C5.55933 35.835 8.06104 33.3333 11.113 33.3333C14.165 33.3333 16.6667 35.835 16.6667 38.887C16.6667 41.939 14.165 44.4407 11.113 44.4407ZM47.2203 0H2.77967C1.25368 0 0 1.24801 0 2.77967V19.4463C0 20.9723 1.24801 22.226 2.77967 22.226H47.2203C48.7463 22.226 50 20.978 50 19.4463V2.77967C50 1.25369 48.752 0 47.2203 0ZM11.113 16.6667C8.05536 16.6667 5.55933 14.165 5.55933 11.113C5.55933 8.06104 8.06104 5.55934 11.113 5.55934C14.165 5.55934 16.6667 8.06104 16.6667 11.113C16.6667 14.165 14.165 16.6667 11.113 16.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/Master.f5560fc085df7ac2c229d038f9ed31d5.svg";
export { ForwardRef as ReactComponent };